import type { FeedType } from '../hooks/use-store'

export const getFeedType = (value?: string | null): FeedType | undefined => {
	if (value === undefined || value === null || value === '') {
		return undefined
	}

	return value === 'internal' ? 'internal' : 'external'
}

export const getFeedTypeFromUrl = (search: string): FeedType => {
	return getFeedType(new URLSearchParams(search).get('feed_type')) ?? 'external'
}
